import { useEffect } from 'react';
import { useAtomValue } from 'jotai';
import { authAtom, getProfile } from './auth.service';

let pending: Promise<unknown> | null = null;

/** The signed-in user (null when signed out). Loads once per page. */
export const useAuth = () => {
    const user = useAtomValue(authAtom);

    useEffect(() => {
        if (user === 0 && !pending) {
            pending = getProfile().finally(() => { pending = null; });
        }
    }, [user]);

    return {
        user: user === 0 ? null : user,
        loading: user === 0,
    };
};
